// extracted by mini-css-extract-plugin
module.exports = {"comment":"comment___AFnTc"};